import { Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useTranslate } from "@/hooks";
import { Hint } from "@/HOC";
import { TCustomTypographyAsCheckboxProps } from "./CustomTypographyAsCheckbox.props";

const CustomTypographyAsCheckbox = ({ label, hint = "", hintPosition, ...props }: TCustomTypographyAsCheckboxProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Hint hint={hint} position={hintPosition}>
			<Typography
				title={translate(label)}
				sx={{
					mt: "2px",
					fontSize: 13,
					marginInline: "3px",
					width: "16px",
					cursor: "pointer", // или "pointer" если нужно сохранить кликабельность
					textAlign: "center",
				}}
				onClick={
					props.onChange
						? () => {
								// Если нужно сохранить возможность переключать состояние по клику на текст
								if (props.disabled) return;
								props.onChange?.(
									{
										target: { checked: !props.checked },
									} as any,
									!props.checked
								);
						  }
						: undefined
				}
			>
				<FontAwesomeIcon icon={props.checked ? faXmark : faCheck} />
			</Typography>
		</Hint>
	);
};

export default CustomTypographyAsCheckbox;
